import { TableCard } from '../../../../components'
import { EspecialidadeListHeader } from './components/header/EspecialidadeListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EspecialidadesTable } from './table/EspecialidadesTable'

const EspecialidadeList = () => {
  return (
    <TableCard>
      <EspecialidadeListHeader />
      <EspecialidadesTable />
    </TableCard>
  )
}

export const EspecialidadeListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <EspecialidadeList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
